import { render } from "./testsuiteparticipantstable.vue?vue&type=template&id=04058812"
import script from "./testsuiteparticipantstable.vue?vue&type=script&lang=js"
export * from "./testsuiteparticipantstable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__